import React, { useEffect, useState } from "react";
import {
  getAgeGradeMembers,
  AgeGradeMember,
  AgeGradeInfo,
} from "services/ageGrade";
import { Link } from "react-router-dom";
import Card from "components/card";
import { useToast } from "components/Toast";

const AgeGrade: React.FC = () => {
  const [members, setMembers] = useState<AgeGradeMember[]>([]);
  const [ageGrade, setAgeGrade] = useState<AgeGradeInfo | null>(null);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState<string | null>(null);
  const toast = useToast();

  useEffect(() => {
    const fetchMembers = async () => {
      try {
        const {
          members: fetchedMembers,
          age_grade,
          message: msg,
        } = await getAgeGradeMembers();
        setMembers(fetchedMembers);
        setAgeGrade(age_grade ?? null);
        if (msg && fetchedMembers.length === 0) {
          setMessage(msg);
        }
      } catch (error) {
        console.error("Failed to fetch age grade members", error);
        toast.showError("Failed to load age grade members.");
        setMessage("Could not load age grade information.");
      } finally {
        setLoading(false);
      }
    };

    fetchMembers();
  }, [toast]);

  return (
    <div>
      <h1 className="mb-4 text-2xl font-bold">
        {ageGrade
          ? `${ageGrade.name} (${ageGrade.min_age} - ${ageGrade.max_age} years)`
          : "Age Grade"}
      </h1>

      <Card extra="p-4">
        {loading ? (
          <p>Loading...</p>
        ) : message ? (
          <p>{message}</p>
        ) : (
          <>
            <h2 className="mb-3 text-lg font-semibold">Members</h2>
            {members.length > 0 ? (
              <ul className="divide-y divide-gray-200 dark:divide-gray-700">
                {members.map((member) => (
                  <li key={member.id} className="py-3">
                    <p className="font-medium text-gray-900 dark:text-white">
                      {member.firstname} {member.lastname}
                    </p>
                    <p className="text-sm text-gray-500 dark:text-gray-400">
                      {member.email}
                    </p>
                    <Link to={`/user/users/${member.id}`}>
                      <button className="mt-2 text-sm text-blue-500 hover:underline">
                        View Profile
                      </button>
                    </Link>
                  </li>
                ))}
              </ul>
            ) : (
              <p>No other members in your age grade.</p>
            )}
          </>
        )}
      </Card>
    </div>
  );
};

export default AgeGrade;
